import { Command } from '@/app/common/base/command'
import { AuthData, TwoFactorMethod } from '@/app/auth/entities/auth-data.entity'

interface LoginCommandResponse {
    twoFactor: boolean
    twoFactorSetup: boolean
    consumerId: string
    twoFactorMethod: TwoFactorMethod
    maskedEmail?: string
    emailOtpExpiresAt?: string
    // Rate limit / lockout state from existing database records
    verifyRateLimited?: boolean
    verifyLockoutSeconds?: number
    emailRateLimited?: boolean
    emailLockoutSeconds?: number
}

export class LoginCommand extends Command {
    public async run(email: string, password: string): Promise<LoginCommandResponse> {
        const response = await this.client.post('/api/auth/login', { email, password })
        const authData = response.asEntity(AuthData)

        // Store the actual data either on a temporary structure for use
        // later in the 2fa process, or as actual login credentials.
        const action = authData.twoFactor ? 'auth/pendingLogin' : 'auth/login'
        await this.store.dispatch(action, { accessToken: authData.accessToken, refreshToken: authData.refreshToken })
        return {
            twoFactor: authData.twoFactor,
            twoFactorSetup: authData.twoFactorSetup,
            consumerId: authData.consumerId,
            twoFactorMethod: authData.twoFactorMethod || 'totp',
            maskedEmail: authData.maskedEmail,
            emailOtpExpiresAt: authData.emailOtpExpiresAt,
            // Pass through rate limit / lockout state
            verifyRateLimited: authData.verifyRateLimited,
            verifyLockoutSeconds: authData.verifyLockoutSeconds,
            emailRateLimited: authData.emailRateLimited,
            emailLockoutSeconds: authData.emailLockoutSeconds
        }
    }
}
